module.exports = __webpack_public_path__ + "images/emoji/no_bicycles.cffc1b5da1871ce09b74.png";